import { FC, HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export const Header: FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...props
}) => (
  <header
    className={twMerge(
      'relative border-b border-primary-default pb-4 pl-6 sm:pl-12 pr-12 pt-6 sm:mx-6 sm:text-center',
      className,
    )}
    {...props}
  >
    {children}
  </header>
)
